import React, { useEffect, useState } from "react";
import {
  CancelButton,
  CountryBadge,
  DeleteButton,
  DuplicateBadge,
  EditButton,
  SafeInput,
  SaveButton,
  TableCell,
  TableRow,
} from "../styles";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { getFlagEmoji } from "../helpers/emoji";

export const ValidRowContact = ({ index, style, data }) => {
  const { items, onEdit, editingId, setEditingId, onDelete } = data;
  const contact = items && items[index];

  // Default object to satisfy hooks when contact is null
  const safeContact = contact || { phone: "", variables: {}, country: "" };

  const isEditing = editingId === `VALID-${index}`;
  const varsArray = safeContact.variables
    ? Object.values(safeContact.variables)
    : [];
  const varKeys = safeContact.variables
    ? Object.keys(safeContact.variables)
    : [];

  // Local state para edición temporal - HOOKS UNCONDITIONAL
  const [tempData, setTempData] = useState({ ...safeContact });

  // Reset temp data when editing starts or contact changes
  useEffect(() => {
    if (isEditing) {
      setTempData({ ...safeContact });
    }
  }, [isEditing, safeContact]); // Depend on safeContact to be stable if index doesn't change

  if (!contact) {
    return <div style={style}>Cargando...</div>;
  }

  const handleSave = () => {
    // Aplicar cambios uno por uno
    if (tempData.phone !== contact.phone) {
      onEdit(index, "VALID", "phone", tempData.phone);
    }

    varKeys.forEach((key) => {
      if (tempData.variables[key] !== contact.variables[key]) {
        onEdit(index, "VALID", key, tempData.variables[key]);
      }
    });

    setEditingId(null);
  };

  return (
    <TableRow style={style}>
      <TableCell flex={1.5}>
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            alignItems: "center",
            width: "100%",
          }}
        >
          {contact.country && (
            <CountryBadge title={contact.country}>
              {getFlagEmoji(contact.country)} {contact.country}
            </CountryBadge>
          )}

          {isEditing ? (
            <SafeInput
              value={tempData.phone}
              onChange={(e) =>
                setTempData({ ...tempData, phone: e.target.value })
              }
              placeholder="Teléfono"
              autoFocus
            />
          ) : (
            <span>{contact.phone}</span>
          )}

          {contact.isDuplicate && (
            <DuplicateBadge>Duplicado</DuplicateBadge>
          )}
        </div>
      </TableCell>

      {varsArray.map((variable, vIndex) => (
        <TableCell key={vIndex} flex={1}>
          {isEditing ? (
            <SafeInput
              value={tempData.variables[varKeys[vIndex]]}
              onChange={(e) =>
                setTempData({
                  ...tempData,
                  variables: {
                    ...tempData.variables,
                    [varKeys[vIndex]]: e.target.value,
                  },
                })
              }
            />
          ) : (
            <span>{variable}</span>
          )}
        </TableCell>
      ))}

      <TableCell
        style={{
          display: "flex",
          gap: "0.5rem",
          justifyContent: "flex-end",
          flex: "0 0 auto",
          overflow: "visible",
          minWidth: isEditing ? "140px" : "60px",
        }}
      >
        {isEditing ? (
          <>
            <SaveButton onClick={handleSave}>Guardar</SaveButton>

            <CancelButton onClick={() => setEditingId(null)}>
              Cancelar
            </CancelButton>
          </>
        ) : (
          <>
            <EditButton
              onClick={() => setEditingId(`VALID-${index}`)}
              title="Editar"
            >
              <FaRegEdit />
            </EditButton>

            <DeleteButton
              onClick={() => onDelete(index, "VALID")}
              title="Eliminar"
            >
              <FaRegTrashAlt />
            </DeleteButton>
          </>
        )}
      </TableCell>
    </TableRow>
  );
};
